import { Col, Row } from "../Grid";
import { withPrefix } from "gatsby-link";
import ContactTab from "./ContactTab";
import PropTypes from "prop-types";
import React from "react";
import countriesContactInfo from "../../content/countriesContactInfo";
import injectSheet from "react-jss";

const styles = theme => ({
  Footer: {
    backgroundColor: theme.colours.palette.blue,
    color: theme.colours.palette.white,
    fontSize: "0.9rem",
    fontWeight: "400",
    maxWidth: "100%",
    paddingLeft: "2rem",
    paddingBottom: "1rem",
    textAlign: "center",
    "@media (max-width: 823px)": {
      display: "none"
    }
  },
  row: {
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%"
  },
  mobileFooter: {
    backgroundColor: theme.colours.palette.blue,
    color: theme.colours.palette.white,
    textAlign: "center",
    fontSize: "0.9rem",
    fontWeight: "400",
    maxWidth: "100%",
    paddingBottom: "2rem",
    "@media (min-width: 824px)": {
      display: "none"
    }
  },
  links: {
    color: theme.colours.palette.white,
    fontSize: "0.9rem",
    fontWeight: "400"
  },
  privacy: {
    paddingTop: "1rem",
    color: "white",
    ":link": {
      color: "white"
    },
    ":visted": {
      color: "white"
    },
    ":hover": {
      color: "white"
    },
    ":active": {
      color: "white"
    }
  }
});

class Footer extends React.Component {
  static propTypes = {
    classes: PropTypes.object
  };

  state = {
    showPrivacyStatement: false
  };

  componentDidMount() {
    // Route legacy URLs to sub-directories of main site
    if (typeof window !== "undefined") {
      if (window.location.href.includes("about")) {
        this.setState({
          showPrivacyStatement: true
        });
      }
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <div className={classes.Footer}>
          <div className={classes.row}>
            {countriesContactInfo.map(country => (
              <ContactTab
                key={country.name}
                name={country.name}
                phonenumber={country.phonenumber}
                salesemail={country.salesemail}
                supportemail={country.supportemail}
                address={country.address}
                linkstyle={classes.links}
              />
            ))}
          </div>
          {this.state.showPrivacyStatement ? (
            <a
              className={classes.privacy}
              href={withPrefix("/privacy-statement.pdf")}
              download="ElectedTechnologiesPrivacyStatement.pdf"
            >
              View our privacy statement
            </a>
          ) : null}
        </div>
        <div className={classes.mobileFooter}>
          <Col center>
            {countriesContactInfo.map(country => (
              <ContactTab
                key={country.name}
                name={country.name}
                phonenumber={country.phonenumber}
                salesemail={country.salesemail}
                supportemail={country.supportemail}
                address={country.address}
                linkstyle={classes.links}
              />
            ))}
          </Col>
          {this.state.showPrivacyStatement ? (
            <a
              className={classes.privacy}
              href={withPrefix("/privacy-statement.pdf")}
              download="ElectedTechnologiesPrivacyStatement.pdf"
            >
              View our privacy statement
            </a>
          ) : null}
        </div>
      </div>
    );
  }
}

export default injectSheet(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx